import { FC, useCallback, useState } from 'react';
import Image from 'next/image';

import CareerAccordion from 'blocks/CareerListSection/components/CareerAccordion';
import { CareerType, CountryCodeType } from 'types/types';
import useLocalised from 'customHooks/useLocalised/useLocalised';
import { careers as careersKey } from 'data/translationKeys';
import CareerTopBg from 'blocks/CareerListSection/assets/career-top-bg.jpeg';
import { Heading } from 'components/text';

interface ICareerListSection {
  careers: CareerType[];
  countryCodes: CountryCodeType[];
}

const CareerListSection: FC<ICareerListSection> = ({
  careers,
  countryCodes,
}) => {
  const [expandedPanelId, setExpandedPanelId] = useState<number | null>(null);

  const handleAccordionChange = useCallback(
    (id: number) => {
      if (expandedPanelId !== null && expandedPanelId === id) {
        setExpandedPanelId(null);
      } else {
        setExpandedPanelId(id);
      }
    },
    [expandedPanelId, setExpandedPanelId]
  );

  const careers_text = useLocalised(careersKey);
  return (
    <>
      <div className="career-list-top">
        <Image
          src={CareerTopBg}
          alt="Career page top background image"
          width={1280}
          height={500}
          layout="responsive"
        />
      </div>
      <div className="career-list-container">
        <h1 className="career-list-container__title">{careers_text}</h1>
        <div className="career-list-container__list">
          {careers.map(career => (
            <CareerAccordion
              key={career.id}
              career={career}
              handleChange={handleAccordionChange}
              expanded={career.id === expandedPanelId}
              countryCodes={countryCodes}
            />
          ))}
        </div>
      </div>
    </>
  );
};

export default CareerListSection;
